import { useState, useEffect } from 'react'
import { getEmpsReportbyAPI } from '../services/employee'

function UseEmpsReportby(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsReportbyAPI({ orgId, searchs })
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return { value: d.username, label: d.username }
      })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseEmpsReportby
